function StopsStatus({ loading, error }) {
    if (loading) return <div>Ładowanie przystanków...</div>;
  
    if (error) {
      return (
        <div className="error-container">
          <h2>Błąd</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Spróbuj ponownie</button>
        </div>
      );
    }
  
    return null;
  }
  
  export default StopsStatus;